import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';

import AboutPillarItem from './components/AboutPillarItem/AboutPillarItem';

const AboutPillarList = () => {
	const { t } = useTranslation();

	return (
		<Fragment>
			<AboutPillarItem title={t('aboutSection.pillars.mission.title')} icon="flag-checkered">
				<span dangerouslySetInnerHTML={{ __html: t('aboutSection.pillars.mission.description') }} />
			</AboutPillarItem>
			<AboutPillarItem title={t('aboutSection.pillars.vision.title')} icon="binoculars" animationDelay={1000}>
				<span dangerouslySetInnerHTML={{ __html: t('aboutSection.pillars.vision.description') }} />
			</AboutPillarItem>
		</Fragment>
	);
};

export default AboutPillarList;
